import { render, staticRenderFns } from "./HeaderHero.vue?vue&type=template&id=0d2c2f16&scoped=true&"
import script from "./HeaderHero.vue?vue&type=script&lang=js&"
export * from "./HeaderHero.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d2c2f16",
  null
  
)

export default component.exports